/**
 * @generated SignedSource<<e6eaa47ba537f18b4ba1781f1084d2fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogPage_catalogPage$data = {
  readonly hotspots: ReadonlyArray<{
    readonly formType: string | null;
    readonly hotspotId: string | null;
    readonly hotspotKey: string | null;
    readonly page: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"CatalogHotspot_hotspot">;
  } | null> | null;
  readonly images: {
    readonly pageCount: number | null;
    readonly prefix: string | null;
    readonly singlePageDimensions: {
      readonly height: number;
      readonly width: number;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogHotspot_catalogPage">;
  readonly " $fragmentType": "CatalogPage_catalogPage";
};
export type CatalogPage_catalogPage$key = {
  readonly " $data"?: CatalogPage_catalogPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogPage_catalogPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogPage_catalogPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogHotspotType",
      "kind": "LinkedField",
      "name": "hotspots",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hotspotId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hotspotKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "page",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CatalogHotspot_hotspot"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogImagesType",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CatalogImagesDimensions",
          "kind": "LinkedField",
          "name": "singlePageDimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CatalogHotspot_catalogPage"
    }
  ],
  "type": "CatalogPage",
  "abstractKey": null
};

(node as any).hash = "af62c2bc137c1cf56bad270f688313dc";

export default node;
